import { useState } from "react"
import { useReactFlow } from "reactflow"
import { v4 as uuid4 } from "uuid"

import { useAuthorizedAxiosClient } from "../../../../common/axios"

export function getNodeFromDropItem(dropItem, translateMousePos) {
  return {
    ...dropItem,
    id: `${dropItem.type}__${uuid4()}`,
    position: translateMousePos(-100, -60),
  }
}

export function getEdgeFromConnection(connection) {
  return { ...connection, type: EDGE_TYPES.customstep }
}

export function useNodeUtils() {
  const reactFlowInstance = useReactFlow()

  function updateNodeEditorData(node, data) {
    updateNodeDataInternal(node, (node2) => ({
      ...node2.data,
      editorData: data,
    }))
  }

  function updateNodeData(node, data) {
    updateNodeDataInternal(node, (node2) => ({ ...node2.data, ...data }))
  }

  function updateNodeDataInternal(node, getMergedData) {
    reactFlowInstance.setNodes((nodes) =>
      nodes.map((node2) =>
        node2.id === node.id ? { ...node2, data: getMergedData(node2) } : node2
      )
    )
  }

  return {
    updateNodeData,
    updateNodeEditorData,
  }
}

export function getEditorData(node) {
  return node.data.editorData
}

export function useUpdateWorkflowStatus() {
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false)
  const axios = useAuthorizedAxiosClient()

  function updateStatus(workflow, newStatus, callback) {
    setIsUpdatingStatus(true)
    return axios
      .put(`/workflows/api/workflows/${workflow.id}/`, {
        ...workflow,
        status: newStatus,
      })
      .then(({ data }) => callback(data))
      .finally(() => setIsUpdatingStatus(false))
  }

  return {
    updateStatus,
    isUpdatingStatus,
  }
}

export const EDGE_TYPES = {
  customstep: "customstep",
}
